export const navbarConstants = {
  GETALL_REQUEST: "WORKFLOWKIND_GETALL_REQUEST",
  GETALL_SUCCESS: "WORKFLOWKIND_GETALL_SUCCESS",
  GETALL_FAILURE: "WORKFLOWKIND_GETALL_FAILURE",
  TOGGLE_SIDEBAR: "TOGGLE_FILTER_SIDEBAR",
  SHOW_SIDEBAR: "SHOW_FILTER_SIDEBAR",
  HIDE_SIDEBAR: "HIDE_FILTER_SIDEBAR",
  TOGGLE_RIGHT_SIDEBAR: "TOGGLE_RIGHT_SIDEBAR"
};
